import axios from 'axios'

export let client = axios.create({
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
})

// UI-only cap. Keep in sync with assessment/rules/timing_latesubmissions.py
export const MAX_LATE_DEDUCTIONS = 15

export function getBarStyle(percent, engagement = true) {
  if (engagement) {
    if (percent >= 66.7) {
      return 'success'
    } else if (percent >= 33.3) {
      return 'warning'
    }
  } else {
    if (percent >= 80) {
      return 'success'
    } else if (percent >= 60) {
      return 'warning'
    }
  }
  return 'danger'
}

/**
  Helper function that converts a string to its associated boolean value
*/
export const convertStringBool = s => s.toLowerCase() === 'true'

/**
  Pseudo sleep function that you can ``await``:

    console.log('counting to three')
    await sleep(3000)
    console.log('done!')
*/
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export const decodeHtml = html => {
  var txt = document.createElement('textarea')
  txt.innerHTML = html
  return txt.value
}

export function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  )
}

export const encodeHtml = txt => {
  var elem = document.createElement('span')
  elem.innerText = txt
  return elem.innerHTML
}
